import type { ProgramTerms } from '../shared';

export const mounjaroTerms: ProgramTerms = {
    'self-pay': null,
    insurance: null,
};
